import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ANALYTICS_EVENT } from '@/common/constants/analyticsEvents';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import { useGuestAuth } from '@/common/contexts/GuestAuthContext';
import { useAnalytics } from '@/common/contexts/AnalyticsContext';
import DiscoverBackButton from './components/discoverBackButton/DiscoverBackButton';
import DiscoverFeed from './components/discoverFeed/DiscoverFeed';
import DiscoverSkeleton from './components/discoverSkeleton/DiscoverSkeleton';
import { DiscoverView } from './discover.styles';
import { useDiscoverPersons } from './hooks/useDiscoverPersons';

const Discover = () => {
	const navigate = useNavigate();
	const t = useLanguageData('discover');
	const { isGuest, openAuthModal } = useGuestAuth();
	const { trackAnalytics } = useAnalytics();
	const { persons, isLoading } = useDiscoverPersons();

	useEffect(() => {
		trackAnalytics(ANALYTICS_EVENT.DISCOVER.OPEN);
	}, []);

	const handleBack = () => {
		trackAnalytics(ANALYTICS_EVENT.DISCOVER.BACK);
		navigate('/');
	};

	const handleSelectProfile = (profile) => {
		if (isGuest) {
			openAuthModal('register');
			return;
		}

		trackAnalytics(ANALYTICS_EVENT.DISCOVER.OPEN_CHAT, {
			personId: profile._id,
		});
		navigate(`/chat/${profile._id}`);
	};

	return (
		<DiscoverView id="discoverView" data-view="discover">
			<DiscoverBackButton onClick={handleBack} ariaLabel={t.back} />
			{isLoading ? (
				<DiscoverSkeleton />
			) : (
				<DiscoverFeed persons={persons} onSelectProfile={handleSelectProfile} />
			)}
		</DiscoverView>
	);
};

export default Discover;
